// ProductPage.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button from "components/CustomButtons/Button.js";
import Accordion from "components/Accordion/Accordion.js";
import Clearfix from "components/Clearfix/Clearfix.js";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Tooltip from "@material-ui/core/Tooltip";
import Cached from "@material-ui/icons/Cached";
import Check from "@material-ui/icons/Check";
import Slider from "nouislider";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Favorite from "@material-ui/icons/Favorite";

import KisetsuNavbar from "components/Header/KisetsuNavbar";
import Footer from "components/Footer/Footer.js";
import Parallax from "components/Parallax/Parallax.js";

import aboutUsStyle from "assets/jss/material-kit-pro-react/views/aboutUsStyle.js";
import productsStyle from "assets/jss/material-kit-pro-react/views/ecommerceSections/productsStyle.js";

import trendyolLogo from "assets/img/logos/trendyol.png";
import hepsiburadaLogo from "assets/img/logos/hepsiburada.png";

const useAboutUsStyles = makeStyles(aboutUsStyle);
const useProductStyles = makeStyles(productsStyle);

export default function ProductPage() {
  const aboutClasses = useAboutUsStyles();
  const productClasses = useProductStyles();

  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedDesigners, setSelectedDesigners] = useState([]);
  const [priceRange, setPriceRange] = useState([101, 790]);
  const [products, setProducts] = useState([]);

  const designers = ["Tuğçe Audoire", "S. Deren Ekşi"];
  const categories = ["Zamansız Ajandalar", "Sticker"];

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    if (
      !document.getElementById("sliderRegular").classList.contains("noUi-target")
    ) {
      Slider.create(document.getElementById("sliderRegular"), {
        start: priceRange,
        connect: true,
        range: { min: 0, max: 2000 },
        step: 1,
      }).on("update", function (values) {
        setPriceRange([Math.round(values[0]), Math.round(values[1])]);
      });
    }

    axios
      .get("https://ecommerce24.pythonanywhere.com/api/products/")
      .then((res) => setProducts(res.data))
      .catch((err) => console.error("Ürün verisi alınamadı", err));
  }, []);

  const filteredProducts = products.filter((p) => {
    const priceOk =
      parseFloat(p.original_price) >= priceRange[0] &&
      parseFloat(p.original_price) <= priceRange[1];

    const categoryOk =
      selectedCategories.length === 0 ||
      selectedCategories.includes(p.product_type);

    const designerOk =
      selectedDesigners.length === 0 ||
      selectedDesigners.includes(p.designer);

    return priceOk && categoryOk && designerOk;
  });

  return (
    <div>
      <KisetsuNavbar />
      <Parallax
        image={require("assets/img/products-banner.jpg")}
        filter="dark"
        small
      >
        <div className={aboutClasses.container}>
          <GridContainer justify="center">
            <GridItem md={8} sm={8} className={classNames(aboutClasses.mlAuto, aboutClasses.mrAuto, aboutClasses.textCenter)}>
              <h1 className={aboutClasses.title}>Mağaza</h1>
              <h4>En yeni ürünlerimizi keşfedin ve tarzınıza uygun koleksiyonları inceleyin.</h4>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>

      <div className={classNames(aboutClasses.main, aboutClasses.mainRaised)}>
        <div className={aboutClasses.container}>
          <div id="products-section" className={aboutClasses.section}>
            <div className={productClasses.container}>
              <GridContainer>
                <GridItem md={3} sm={12}>
                  <Card plain>
                    <CardBody className={productClasses.cardBodyRefine}>
                      <h4 className={productClasses.cardTitle + " " + productClasses.textLeft}>
                        Filtrele
                        <Tooltip title="Filtreyi Sıfırla" placement="top" classes={{ tooltip: productClasses.tooltip }}>
                          <Button
                            link
                            justIcon
                            size="sm"
                            className={productClasses.pullRight + " " + productClasses.refineButton}
                            onClick={() => {
                              setSelectedCategories([]);
                              setSelectedDesigners([]);
                            }}
                          >
                            <Cached />
                          </Button>
                        </Tooltip>
                        <Clearfix />
                      </h4>
                      <Accordion
                        active={[0, 1, 2]}
                        activeColor="rose"
                        collapses={[
                          {
                            title: "Fiyat Aralığı",
                            content: (
                              <CardBody className={productClasses.cardBodyRefine}>
                                <span className={classNames(productClasses.pullLeft, productClasses.priceSlider)}>₺{priceRange[0]}</span>
                                <span className={classNames(productClasses.pullRight, productClasses.priceSlider)}>₺{priceRange[1]}</span>
                                <br /><br />
                                <div id="sliderRegular" className="slider-rose" />
                              </CardBody>
                            ),
                          },
                          {
                            title: "Ürün Kategorisi",
                            content: (
                              <div className={productClasses.customExpandPanel}>
                                {categories.map((item, index) => (
                                  <FormControlLabel
                                    key={index}
                                    control={
                                      <Checkbox
                                        disableRipple
                                        tabIndex={-1}
                                        onClick={() => {
                                          const exists = selectedCategories.includes(item);
                                          if (exists) {
                                            setSelectedCategories(selectedCategories.filter(i => i !== item));
                                          } else {
                                            setSelectedCategories([...selectedCategories, item]);
                                          }
                                        }}
                                        checked={selectedCategories.includes(item)}
                                        checkedIcon={<Check className={productClasses.checkedIcon} />}
                                        icon={<Check className={productClasses.uncheckedIcon} />}
                                        classes={{ checked: productClasses.checked, root: productClasses.checkRoot }}
                                      />
                                    }
                                    classes={{ label: productClasses.label }}
                                    label={item}
                                  />
                                ))}
                              </div>
                            ),
                          },
                          {
                            title: "Tasarımcı",
                            content: (
                              <div className={productClasses.customExpandPanel}>
                                {designers.map((item, index) => (
                                  <FormControlLabel
                                    key={index}
                                    control={
                                      <Checkbox
                                        disableRipple
                                        tabIndex={-1}
                                        onClick={() => {
                                          const exists = selectedDesigners.includes(item);
                                          if (exists) {
                                            setSelectedDesigners(selectedDesigners.filter(i => i !== item));
                                          } else {
                                            setSelectedDesigners([...selectedDesigners, item]);
                                          }
                                        }}
                                        checked={selectedDesigners.includes(item)}
                                        checkedIcon={<Check className={productClasses.checkedIcon} />}
                                        icon={<Check className={productClasses.uncheckedIcon} />}
                                        classes={{ checked: productClasses.checked, root: productClasses.checkRoot }}
                                      />
                                    }
                                    classes={{ label: productClasses.label }}
                                    label={item}
                                  />
                                ))}
                              </div>
                            ),
                          },
                        ]}
                      />
                    </CardBody>
                  </Card>
                </GridItem>

                <GridItem md={9} sm={12}>
                  <GridContainer>
                    {filteredProducts.map((item, index) => (
                      <GridItem md={4} sm={6} xs={12} key={index}>
                        <Card product plain>
                          <Link to={`/products/${item.slug}`}>
                            <CardHeader image plain>
  <div style={{ position: "relative" }}>
    {/* İNDİRİMLİ ÜRÜN ETİKETİ */}
    {parseFloat(item.discounted_price) > 0 && (
      <div className={productClasses.discountBadge}>İNDİRİMLİ ÜRÜN</div>
    )}

    <img
      src={`https://ecommerce24.pythonanywhere.com${item.cover_image}`}
      style={{ width: "100%", objectFit: "cover", aspectRatio: "1/1" }}
      alt={item.name}
    />
    <div
      className={productClasses.coloredShadow}
      style={{ backgroundImage: `url(https://ecommerce24.pythonanywhere.com${item.cover_image})`, opacity: 1 }}
    />
  </div>
</CardHeader>

                          </Link>
                          <CardBody className={productClasses.textCenter} plain>
                            <Link to={`/products/${item.slug}`} style={{ textDecoration: "none", color: "inherit" }}>
                              <h4 className={productClasses.cardTitle}>{item.name}</h4>
                            </Link>
                            <p className={productClasses.cardDescription}>
                              {item.product_type} - {item.designer}
                            </p>
                          </CardBody>
                          <CardFooter plain style={{ justifyContent: "center", gap: "1rem" }}>
                            <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
                              {item.trendyol_url && (
                                <Button justIcon target="_blank" href={item.trendyol_url} color="white">
                                  <img src={trendyolLogo} alt="Trendyol" style={{ height: 24 }} />
                                </Button>
                              )}
                              {item.hepsiburada_url && (
                                <Button justIcon target="_blank" href={item.hepsiburada_url} color="white">
                                  <img src={hepsiburadaLogo} alt="Hepsiburada" style={{ height: 24 }} />
                                </Button>
                              )}
                            </div>
                          </CardFooter>
                        </Card>
                      </GridItem>
                    ))}
                  </GridContainer>
                </GridItem>
              </GridContainer>
            </div>
          </div>
        </div>
      </div>

      <Footer
        content={
          <div>
            <div className={aboutClasses.left}>
              <List className={aboutClasses.list}>
                <ListItem className={aboutClasses.inlineBlock}><a href="/blog-posts" className={aboutClasses.block}>Blog</a></ListItem>
                <ListItem className={aboutClasses.inlineBlock}><a href="/about-us" className={aboutClasses.block}>Hakkımızda</a></ListItem>
                <ListItem className={aboutClasses.inlineBlock}>
              <a href="/products" className={aboutClasses.block}>Mağaza</a>
            </ListItem>
              <ListItem className={aboutClasses.inlineBlock}>
              <a href="/contact-us" className={aboutClasses.block}>İletişim</a>
            </ListItem>
              </List>
            </div>
            <div className={aboutClasses.right}>
              &copy; {1900 + new Date().getYear()}, sevgiyle tasarlandı <Favorite className={aboutClasses.icon} /> <a href="/" target="_blank" rel="noopener noreferrer">Kisetsu</a> ile daha düzenli bir hayat için.
            </div>
          </div>
        }
      />
    </div>
  );
}
